module.exports = __webpack_public_path__ + "static/media/Cash.1bb3d0b1.png";